var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallationTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "EstimTime",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #EstimTime .cls-1 {\n        fill: #ed1e79;\n      }\n\n      #EstimTime .cls-2 {\n        clip-path: url(#EstimTime-clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "EstimTime-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,32A16,16,0,1,1,32,16,16,16,0,0,1,16,32M16,1.72A14.28,14.28,0,1,0,30.28,16,14.28,14.28,0,0,0,16,1.72Zm1.776,14.738c-.007.277-.028.555-.028.833v.119a5.146,5.146,0,0,0,1.008-.529,4.425,4.425,0,0,0-.875-.488c-.078-.035-.105-.024-.105.065m-6.587,1.736a5.414,5.414,0,0,1,.76-1.114,6.051,6.051,0,1,1,2.885,1.364l-.016,1.349a6.832,6.832,0,0,0,2.692-.122l.03-.009a7.228,7.228,0,0,0,1.289-.44l0,0c.2-.092.4-.193.6-.3l.02-.012c.19-.109.376-.226.557-.353a7.28,7.28,0,1,0-8.817-.357m4.666-4.848,4.054-.125a.668.668,0,0,0,.648-.688.657.657,0,0,0-.689-.648l-3.365.1V7.771a.669.669,0,1,0-1.337,0v4.906a.667.667,0,0,0,.669.669h.02m4.584,5.817a7.984,7.984,0,0,1-2.724,1.229v.02a.878.878,0,0,1-.776.8,1.731,1.731,0,0,1-.268.03c-.282.008-.564.016-.846.016a4.052,4.052,0,0,1-1.03-.094.849.849,0,0,1-.663-.676c0-.017,0-.035-.006-.052a2.527,2.527,0,0,1-.059-.548q.015-1.212.031-2.423l.012-.9a.3.3,0,0,0-.009-.132c-.038-.009-.066.015-.1.032a4.3,4.3,0,0,0-.867.542c-.091.072-.189.136-.274.215a4.9,4.9,0,0,0-1.545,3.165,4.234,4.234,0,0,0,1.1,3.313,3.95,3.95,0,0,1,.312.371,2.421,2.421,0,0,1,.4,1.464c0,.187,0,1.973,0,2.16a6.358,6.358,0,0,0,2.965.647,6.362,6.362,0,0,0,2.6-.477c0-.371,0-2.341,0-2.712a1.18,1.18,0,0,1,.254-.73,2.185,2.185,0,0,1,.253-.256,4.707,4.707,0,0,0,1.239-5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallationTime);
export default __webpack_public_path__ + "static/media/installation-time.e40aa398005bba99f1ca45a949a1897e.svg";
export { ForwardRef as ReactComponent };